module.exports = __webpack_public_path__ + "static/media/history_33.142dd4fd.jpg";